import { PAGE_TYPES } from '@dashboard/enums/page-types';

export function getPageCurrency(page = {}) {
  if (page.type === PAGE_TYPES.CHECKOUT) {
    return page.product?.currency;
  }

  if (page.type === PAGE_TYPES.EVENT) {
    return page.eventDetails?.currency;
  }

  return 'USD';
}
